import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {Authenticate, AuthenticateByAccessToken, AuthenticateWorkflow, AuthenticationFailure, AuthenticationSuccess, AuthenticationWorkflowFailure, AuthenticationWorkflowSuccess, ClearAll, ClearAuthStore, EAuthenticationActions, Logout, LogoutFailure, LogoutSuccess, SetToken, SetTokenSuccess} from "../../actions/security/authentication.actions";
import {catchError, map, mapTo, switchMap, tap, withLatestFrom} from "rxjs/operators";
import {LoadAuthenticatedUser} from "../../actions/security/authenticated-user.actions";
import {Store} from "@ngrx/store";
import {DeviceDetectorService} from 'ngx-device-detector';
import {IAppState} from "../../state/app.state";
import {ApiAuthenticationService} from "../../../../api/external/api-services/api-authentication/api-authentication.service";
import {IAuthServiceResponse, ILogoutServiceResponse, IValidateTokenServiceResponse} from "@retail-data-factory/rdf-angular-types-api";
import {ClearMDMStore, InitMDMStore, LoadHierarchyListSuccess} from "../../actions/mdm/mdm.actions";
import {Router} from "@angular/router";
import {GetPartners} from "../../actions/partners/partners.actions";
import {of} from "rxjs";
import {IRdfServiceResponseError} from "../../../../services/external-api/response-interfaces";
import {MessageService} from "@retail-data-factory/rdf-angular-messages";
import {SpinnerService} from "@retail-data-factory/rdf-angular-utils";
import {ApiWorkflowService} from "../../../../api/external/api-services/api-workflow/api-workflow.service";
import {ConfigurationManager} from "../../../configuration-manager/configuration-manager";
import {LoggerService} from "../../../../services/external-api/logger.service";
import {AssistTranslationService} from "@retail-data-factory/rdf-angular-translation-service";
//import {RdfCustomReportingService} from "../../../../custom-reporting/rdf-custom-reporting/services/rdf-custom-reporting.service";
import {LoadSubscriptions} from "../../actions/marketplace/marketplace.actions";
import {ApiOrdersService} from "../../../../api/external/api-services/api-orders/api-orders.service";

@Injectable()
export class AuthenticationEffects {
  SetToken$ = createEffect(() => this._actions$.pipe(
    ofType<SetToken>(EAuthenticationActions.SetToken),
    mapTo(new SetTokenSuccess())
  ));
  SetTokenSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<SetTokenSuccess>(EAuthenticationActions.SetTokenSuccess),
    withLatestFrom(this._store$),
    tap(
      ([action, storeState]) => {
        //this._store$.dispatch(new LoadAuthenticatedUser());
        //this._store$.dispatch(new GetResources());
        //this._store$.dispatch( new GetPartnerCreditLimitAmount(partner.partyId));
        console.log('SetToken effect');
      }
    )
  ),{dispatch: false});
  Authenticate$ =  createEffect(() => this._actions$.pipe(
    ofType<Authenticate>(EAuthenticationActions.Authenticate),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        this.spinnerService.show();
        return this.apiAuthenticationService.authenticateByLogin(action.payload.login, action.payload.password)
          .pipe(
            map((data: IAuthServiceResponse) => {
                console.log('browser is', this.deviceService.browser);
                if (data.access_token) {
                  //Временно


                  return new AuthenticationSuccess({accessToken: data.access_token, workflowToken: ''});

                } else {
                  return new AuthenticationFailure();
                }
              }
            ),
            catchError((error: IRdfServiceResponseError) => {
              console.log('browser is', this.deviceService.browser);
              if (error.errorCode === 401) {
//                this.messageService.error('Retail Data Factory', this.assistTranslationService.instant(`login.${this.configurationManager.configuration.theme}.errorPasswordMessage`));
                this.messageService.error('Retail Data Factory', this.assistTranslationService.getServiceErrorMessage(error.rdfErrorCode, `login.${this.configurationManager.configuration.theme}.errorPasswordMessage`));
              } else {
//                this.messageService.error('Retail Data Factory', this.assistTranslationService.instant('common.unknownError'));
                this.messageService.error('Retail Data Factory', this.assistTranslationService.getServiceErrorMessage(error.rdfErrorCode, 'common.unknownError'));
              }
              console.error(error);
              return of(new AuthenticationFailure());
            })
          );
      }
    )
  ));
  AuthenticationSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<AuthenticationSuccess>(EAuthenticationActions.AuthenticationSuccess),
    withLatestFrom(this._store$),
    tap(
      ([action, storeState]) => {
        //logger.print(`Navigating to default page ${environment.start_page}`, 'info');
        //window.localStorage.setItem('access_token')
  //      this.rdfCustomReportingService.clearParameters();
        //this.spinnerService.hide();
        this.loggerService.log('AuthenticationSuccess', 'Authentication', storeState.viewElements.displaySize, '', '', 'INFO', '', '0');
        this._store$.dispatch(new GetPartners());
        this._store$.dispatch(new LoadAuthenticatedUser());
        this._store$.dispatch(new LoadSubscriptions());
//        this._store$.dispatch(new GetResources());
        // const route = this.router.url;
        // if (route==='/login') {
        //   this.router.navigateByUrl('/' + this.configurationManager.configuration.start_page).catch(error => console.error(error));
        // }
        console.log('AuthenticationSuccess effect');
      }
    )
  ),{dispatch: false});

  AuthenticationFailure$ = createEffect(()=>this._actions$.pipe(
    ofType<AuthenticationFailure>(EAuthenticationActions.AuthenticationFailure),
    withLatestFrom(this._store$),
    tap(
      ([action, storeState]) => {
        this.spinnerService.hide();
        window.localStorage.removeItem('access_token');
        window.localStorage.removeItem('workflow_token');
        this.router.navigateByUrl('/login').catch(error => console.error(error));
        console.log('AuthenticationFailure effect');
      }
    )
  ),{dispatch: false});


    AuthenticateByAccessToken$ = createEffect(() => this._actions$.pipe(
    ofType<AuthenticateByAccessToken>(EAuthenticationActions.AuthenticateByAccessToken),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        this.spinnerService.show();
        return this.apiAuthenticationService.validateToken(action.payload.accessToken)
          .pipe(
            map((data: IValidateTokenServiceResponse) => {
                if (data.Login) {
                  return new AuthenticationSuccess({accessToken: action.payload.accessToken, workflowToken: action.payload.workflowToken});
                } else {
                  return new AuthenticationFailure();
                }
              }
            )
          )
          // ,catchError((error: IRdfServiceResponseError) => {
          //   console.error(error);
          //   return of(new AuthenticationFailure());
          //
          // })
          ;
      }
    )
  )
    );


  AuthenticateByGoogleToken$ = createEffect(() => this._actions$.pipe(
    ofType<AuthenticateByAccessToken>(EAuthenticationActions.AuthenticateByOidc),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        this.spinnerService.show();
        return this.apiAuthenticationService.authenticateByGoogle(action.payload['oidcToken'])
          .pipe(
            map((data: IAuthServiceResponse) => {
                if (data.access_token) {
                  return new AuthenticationSuccess({accessToken: data.access_token, workflowToken: ''});
                } else {
                  return new AuthenticationFailure();
                }
              }
            ),
            catchError((error, caught)=>{
              console.error(error);
              return of(new AuthenticationFailure());
            })



            //,
            // catchError(error=>{
            //   console.error(error);
            //   this.spinnerService.hide();
            //
            //   return of(new AuthenticationFailure());
            //
            // })
          );
        //  ,catchError((error: IRdfServiceResponseError) => {
        //    console.error(error);
        // this.spinnerService.hide();
        //
        // return of(new AuthenticationFailure());
        //
        //  }
        //  )
        // ;
      }
    )
  ));

  AuthenticateWorkflow$ = createEffect(() => this._actions$.pipe(
    ofType<AuthenticateWorkflow>(EAuthenticationActions.AuthenticateWorkflow),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        return this.apiWorkflowService.authenticate(storeState.authentication.data.login, storeState.authentication.data.password, storeState.authentication.data.accessToken)
          .pipe(
            map((data) => {
                if (data.ssoToken) {
                  return new AuthenticationWorkflowSuccess(data);
                } else {
                  return new AuthenticationWorkflowFailure();
                }
              }
            )
          );
      }
    )
  ));
  AuthenticationWorkflowSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<AuthenticationWorkflowSuccess>(EAuthenticationActions.AuthenticationWorkflowSuccess),
    withLatestFrom(this._store$),
    tap(
      ([action, storeState]) => {

        window.localStorage.setItem('workflow_token', action.payload.ssoToken);
        console.log('AuthenticationWorkflowSuccess effect');
      }
    )
  ),{dispatch: false});

  Logout$ = createEffect(() => this._actions$.pipe(
    ofType<Logout>(EAuthenticationActions.Logout),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        return this.apiAuthenticationService.logout(storeState.authentication.data.accessToken)
          .pipe(
            map((data: ILogoutServiceResponse) => {
                if (data.Error === 0) {
                  return new LogoutSuccess();
                } else {
                  return new LogoutFailure();
                }
              }
            ),
            catchError((error: IRdfServiceResponseError) => {
              console.error(error);
              return of(new LogoutFailure());
            })
          );
      }
    )
  ));
  LogoutSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<LogoutSuccess>(EAuthenticationActions.LogoutSuccess),
    withLatestFrom(this._store$),
    tap(
      ([action, storeState]) => {

        this.logout();

        console.log('LogoutSuccess effect');
      }
    )
  ),{dispatch: false});
  LogoutFailure$ = createEffect(() => this._actions$.pipe(
    ofType<LogoutFailure>(EAuthenticationActions.LogoutFailure),
    withLatestFrom(this._store$),
    tap(
      ([action, storeState]) => {

        this.logout();
        console.log('LogoutFailure effect');
      }
    )
  ),{dispatch: false});


  ClearAll$ = createEffect(() => this._actions$.pipe(
    ofType<ClearAll>(EAuthenticationActions.ClearAll),
    withLatestFrom(this._store$),
    tap(
      ([action, storeState]) => {
        this.apiOrdersService.clearBasket();
        this._store$.dispatch(new ClearAuthStore());
        this._store$.dispatch(new ClearMDMStore());
        console.log('ClearAll effect');
      }
    )
  ),{dispatch: false});

  logout() {
    //this.apiOrdersService.clearBasket();
   // this.rdfCustomReportingService.clearParameters();
    const savedLang = window.localStorage.getItem('lang');
    window.localStorage.clear();
    if (savedLang) {
      window.localStorage.setItem('lang', savedLang);
    }


    this.router.navigateByUrl('/login')
      .then(() => {
        //if (this.deviceService.browser === 'Firefox') {
        //location.reload();
        //}
      })
      .catch(error => console.error(error));


    this._store$.dispatch(new ClearAll());


    console.log('LogoutSuccess effect');
  }


  constructor(
    private _actions$: Actions,
    private _store$: Store<IAppState>,
    private apiAuthenticationService: ApiAuthenticationService,
//    private userService: UserService,
    private router: Router,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    private configurationManager: ConfigurationManager,
    private assistTranslationService: AssistTranslationService,
    private deviceService: DeviceDetectorService,
    private apiWorkflowService: ApiWorkflowService,
    private loggerService: LoggerService,
    private apiOrdersService: ApiOrdersService,
   // private rdfCustomReportingService: RdfCustomReportingService
  ) {
  }

}
